import React, { useEffect, useState, useDispatch } from "react";
import { Link } from "react-router-dom";
import SignUp from "./SignUp";
import ReactGA from "react-ga";
import { ReactComponent as RadarrLogo } from "../../../assets/radarr-logo-green.svg";
import { ReactComponent as Chevron } from "../../../assets/svg/chevron.svg";
import connectingDots from "./connections-dots.png";
import productImage1 from "./product-img-1.webp";
import productImage2 from "./product-img-2.webp";
import award1 from "./award1.jpg";
import award2 from "./award2.jpg";
import award3 from "./award3.png";
import "./SignUpContainer.scss";
import { updateRouteValues } from "../../../actions/globalAction";
import Login from "../Login";

const SignInContainerCloned = (props) => {
    useEffect(() => {
        zE("webWidget", "updateSettings", { color: { theme: "#00bfa3" } });
        zE("webWidget", "show");

        document.title = "Login - Best Social Listening Platform";

        return () => {
            zE("webWidget", "hide");
        };
    }, []);

    useEffect(() => {
        // console.log("kllkklkllkl",window.location.pathname)
        // let route = {
        //     to: window.location.pathname,
        //     from: prevProps.location.pathname,
        // };
        // this.props.updateRouteValues(route);
    }, [props]);

    const scrollTop = () => {
        window.scroll({ top: 0, left: 0, behavior: "smooth" });
    };

    const texts = [
        {
            main: "Track every consumer",
            sub: "trend and sentiment",
            text: "Keep track of what’s trending across the globe. Scan consumer sentiments in real time and set up alerts to manage brand reputation.",
        },
        {
            main: "Turn online conversations",
            sub: "into brand insights",
            text: "Powered by AI, we are the best social listening, monitoring and tracking platform that helps you get better results faster.",
        },
        {
            main: "Benchmark your performance",
            sub: "and find new opportunities",
            text: "Use our Al powered social analytics and intelligence tool to get in-depth analysis of your campaigns. Uncover untapped opportunities to get ahead!",
        },
        {
            main: "Track",
            sub: "competitors",
            text: "Simplified business intelligence with our intuitive competitor tracking platform. Have the information you need to be a step ahead.",
        },
    ];
    const TextContainer = () => {
        const [index, setIndex] = useState(0);
        useEffect(() => {
            const interval = setInterval(() => {
                if (index === 3) setIndex(0);
                else setIndex(index + 1);
            }, 4000);

            return () => {
                clearInterval(interval);
            };
        }, [index]);

        return (
            <div className="TextContainer">
                <p className="main">{texts[index].main}</p>
                <p className="sub">{texts[index].sub}</p>
                <p className="text">{texts[index].text}</p>
            </div>
        );
    };

    return (
        <div className="signup-container">
            <div className="signup-main">
                <div className="signup-contents">
                    <div className="signup-left">
                        <div className="signup__left-wrap">
                            <TextContainer />
                        </div>
                    </div>
                    <div className="signup-right">
                        <Login wlSignIn={true} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignInContainerCloned;
